import styled, { css } from 'styled-components';
import { CircleDismissButton } from '../DismissingCard/CircleDismissButton.js';

const Container = styled.div.withConfig({
    displayName: "styles__Container",
    componentId: "sc-c09bbfaf-0"
})`
    width: 100%;
    display: flex;
    border: none;
    border-radius: 8px;
    max-width: ${({ isFullWidth  })=>isFullWidth ? "unset" : "448px"};
    padding: ${(props)=>props.theme.spacers.M};
    background-color: ${(props)=>props.backgroundColor ?? "rgba(255, 199, 0, 0.1)"};
`;
const IconWrap = styled.div.withConfig({
    displayName: "styles__IconWrap",
    componentId: "sc-c09bbfaf-1"
})`
    flex-shrink: 0;
    margin-right: ${(props)=>props.theme.spacers.M};
    height: 20px;
`;
const Text = styled.p.withConfig({
    displayName: "styles__Text",
    componentId: "sc-c09bbfaf-2"
})`
    color: ${(props)=>props.color ?? props.theme.colors["Level 5"]};
    ${(props)=>css(props.theme.typography.TinyParagraph)};
    align-self: center;
`;
const DismissibleHintContainer = styled(Container).withConfig({
    displayName: "styles__DismissibleHintContainer",
    componentId: "sc-c09bbfaf-3"
})`
    display: block;
`;
const DismissibleHintContent = styled.div.withConfig({
    displayName: "styles__DismissibleHintContent",
    componentId: "sc-c09bbfaf-4"
})`
    display: flex;
    flex-direction: row;
    margin-right: 22px;
`;
const DismissButton = styled(CircleDismissButton).withConfig({
    displayName: "styles__DismissButton",
    componentId: "sc-c09bbfaf-5"
})`
    background-color: transparent;
    width: 20px;
    height: 20px;
`;

export { Container, DismissButton, DismissibleHintContainer, DismissibleHintContent, IconWrap, Text };
